import DeclaracaoSaude from './DeclaracaoSaude';

export default DeclaracaoSaude;
